import { render, staticRenderFns } from "./EmployeeEducation.vue?vue&type=template&id=2d069b81"
import script from "./EmployeeEducation.vue?vue&type=script&lang=js"
export * from "./EmployeeEducation.vue?vue&type=script&lang=js"
import style0 from "./EmployeeEducation.vue?vue&type=style&index=0&id=2d069b81&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports